<template>
  <span class="text-xl text-nowrap font-bold">
    ArabQuant <span class="text-primary font-bold">traid</span></span
  >
</template>
